import { FC, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import Dialog from 'components/base/Dialog';
import AgreementInfo from 'components/forms/AgreementInfo';
import { getFullName } from 'components/forms/RealNameInfo';
import Toast from 'components/Toast';
import security from 'stores/security';
import values from 'stores/values';
import { CustomerInfoType, LicenseEnum } from 'types/customer';
import { reportEventList } from 'utils/gtag';
import { openAccount } from 'utils/request';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Agreements: FC<ProgressFormProps> = ({ onSubmit }) => {
    const navigate = useNavigate();
    const storageInfo = values.getParams<CustomerInfoType>();
    const { account_capabilities: accountCapability, opt_perm, treasury_perm, category } = storageInfo;
    const name = getFullName(storageInfo);

    const handleSubmit = (ev: FormEvent) => {
        onSubmit(async () => {
            Toast.loading(true, __('Loading'));

            reportEventList('agreement');

            try {
                const params = values.getParams();

                params.tax_residence_country = 'USA';
                params.legal_residence_country = 'USA'; // 新版填写移除 写死传入USA

                params.account_type = 'ib';
                params.tax_identification_number = params.id_no;
                params.base_currency = 'USD'; // 新版必传入项
                // 目前只有Marsco一个清算商开户
                params.clearing = 'marsco';
                params.license = LicenseEnum.MARSCO;

                const { customer_id } = await openAccount(params);

                // 开户资料提交后需要获取用户状态信息(用户的statusCode有变化)
                try {
                    await security.getOpenProcess(customer_id);
                    values.clear();
                    navigate('../complete');
                } catch (error) {
                    // 如果获取状态失败，需要提醒用户去登录个人中心继续
                    await Dialog.alert({
                        title: __('System Error'),
                        content: error.message,
                        hideCloseBtn: true
                    });

                    window.location.href = '/profile';
                }
            } catch (error) {
                Toast.show(error);
            }

            Toast.loading(false);
        }, ev);
    };

    return (
        <form noValidate className="open-agreement-root" onSubmit={handleSubmit}>
            <AgreementInfo
                license={LicenseEnum.MARSCO}
                name={name}
                accountCapability={accountCapability}
                perms={{ opt_perm, treasury_perm }}
                category={category}
            />
            <BackNextButtons
                nextBtnProps={{
                    content: __('Submit')
                }}
                sticky
            />
        </form>
    );
};

export default withProgressForm({
    id: 'agreements',
    ensure: ['baseinfo', 'job', 'invest'],
    basePath: 'open',
    showProgressBar: false,
    eventParams: {
        exposureEventParams: {
            model: '开户-协议与披露',
            name: '协议与披露-页面曝光'
        },
        submitEventParams: {
            model: '开户-协议与披露',
            name: '协议与披露-点击提交'
        }
    }
})(Agreements);
